export function hasPreScheduleAnswer(medicalRecord) {
  return Boolean(
    medicalRecord?.id_sched
    && medicalRecord?.schedule?.pre_schedule_answer?.answered_at,
  );
}

export function availableSideTabs(medicalRecord) {
  const tabs = [];

  if (hasPreScheduleAnswer(medicalRecord)) {
    tabs.push({
      id: 'pre-schedule',
      label: 'Pré-agendamento',
      icon: 'bi bi-clipboard-check',
      btnClass: 'nav-btn-primary',
    });
  }

  if (medicalRecord?.record_type?.allow_prescription) {
    tabs.push({
      id: 'prescription',
      label: 'Prescrição',
      icon: 'bi bi-file-earmark-medical',
      btnClass: 'nav-btn-primary',
    });
  }

  if (medicalRecord?.record_type?.allow_exam_request) {
    tabs.push({
      id: 'exam',
      label: 'Exames',
      icon: 'bi bi-clipboard2-pulse',
      btnClass: 'nav-btn-secondary',
    });
  }

  if (medicalRecord?.record_type?.allow_programs) {
    tabs.push({
      id: 'programs',
      label: 'Programas',
      icon: 'bi bi-bullseye',
      btnClass: 'nav-btn-primary',
    });
  }

  tabs.push({
    id: 'health-data',
    label: 'Dados de saúde',
    icon: 'bi bi-heart-pulse',
    btnClass: 'nav-btn-success',
  });

  if (medicalRecord?.record_type?.allow_document) {
    tabs.push({
      id: 'document',
      label: 'Documentos',
      icon: 'bi bi-file-earmark-text',
      btnClass: 'nav-btn-primary',
    });
  }

  tabs.push({
    id: 'attachment',
    label: 'Anexos',
    icon: 'bi bi-paperclip',
    btnClass: 'nav-btn-primary',
  });

  return tabs;
}

export function clinicalRecordTabs(medicalRecord) {
  const tabs = [
    {
      id: 'prontuario',
      label: 'Prontuário',
      icon: 'bi bi-journal-medical',
    },
    ...availableSideTabs(medicalRecord),
  ];

  if (medicalRecord?.record_type?.allow_document) {
    tabs.push({
      id: 'cid',
      label: 'CID',
      icon: 'bi bi-tags',
    });
  }

  return tabs;
}

export function isSideTabAllowed(medicalRecord, tabName) {
  if (tabName === 'prontuario') {
    return true;
  }

  if (tabName === 'pre-schedule') {
    return hasPreScheduleAnswer(medicalRecord);
  }

  if (tabName === 'prescription') {
    return !!medicalRecord?.record_type?.allow_prescription;
  }

  if (tabName === 'exam') {
    return !!medicalRecord?.record_type?.allow_exam_request;
  }

  if (tabName === 'document' || tabName === 'cid') {
    return !!medicalRecord?.record_type?.allow_document;
  }

  if (tabName === 'programs') {
    return !!medicalRecord?.record_type?.allow_programs;
  }

  return ['health-data', 'attachment'].includes(tabName);
}

export function defaultSideTab(medicalRecord, layout = 'classic') {
  if (layout === 'clinical') {
    return 'prontuario';
  }

  if (hasPreScheduleAnswer(medicalRecord)) {
    return 'pre-schedule';
  }

  if (medicalRecord?.record_type?.allow_prescription) {
    return 'prescription';
  }

  if (medicalRecord?.record_type?.allow_exam_request) {
    return 'exam';
  }

  if (medicalRecord?.record_type?.allow_programs) {
    return 'programs';
  }

  if (medicalRecord?.record_type?.allow_document) {
    return 'document';
  }

  return 'health-data';
}
